import { isUndefined } from 'util';
import { LightShowOperation } from './Operations/lightshow-operation';

export enum EditorMode {
  TORCH = 'TORCH',
  SCREEN = 'SCREEN'
}

export enum SegmentMode {
  COLOR = 'COLOR',
  IMAGE = 'IMAGE',
  SOUND = 'SOUND'
}

export class LightshowState {
  public playbackPosition: number;
  public isFlashOn: boolean;
  public brightness: number;
  public screenColor: string;
  public imageUrl: string;
  public imageOpacity: number;
  public preloadCache: any = {};
  public isSoundEffectPlaying: boolean;

  _isPlaying: boolean;
  public get isPlaying(): boolean {
    return this._isPlaying;
  }
  public set isPlaying(val: boolean) {
    this._isPlaying = val;
    if (!val) {
      this._audioLayers.forEach(al => al.audio.pause());
    }
  }

  private _audioLayers?: { layerId: string; audio: HTMLAudioElement }[] = [];

  constructor() {
    this.isPlaying = false;
    this.isFlashOn = false;
    this.screenColor = '#000000';
    this.imageOpacity = 1;
    this.imageUrl = null;
    this.playbackPosition = 0;
  }

  public preloadImage(url: string) {
    if (this.preloadCache[url] === undefined) {
      const image = new Image();
      image.src = url;
      this.preloadCache[url] = image;
    }
  }

  public preloadAudio(url: string) {
    if (this.preloadCache[url] === undefined) {
      const audio = new Audio(url);
      audio.load();
      this.preloadCache[url] = audio;
    }
  }

  seekPosition(position: number, operations: LightShowOperation[]) {
    this.playbackPosition = position;

    // set start data
    this.isFlashOn = false;
    this.imageUrl = null;
    this.screenColor = '#ffffff';
    this.imageOpacity = 0;

    // apply operations
    if (operations) {
      operations.filter(op => op.position + op.duration < position).forEach(op => op.end(this));
      operations.filter(op => op.position <= position && position <= op.position + op.duration).forEach(op => op.tick(this));
    }
  }

  public RemoveAudioLayer(layerId: string) {
    const layerToRemove = this._audioLayers.find(al => al.layerId === layerId);
    if (layerToRemove) {
      layerToRemove.audio.pause();
      this._audioLayers.splice(this._audioLayers.indexOf(layerToRemove), 1);
    }
  }

  public SetAudioLayer(layerId: string, url: string, position: number): void {
    let layer = this._audioLayers.find(a => a.layerId === layerId);
    if (layer) {
      // update existing layer's url if changed
      if (decodeURI(layer.audio.src).toLowerCase() !== decodeURI(url).toLowerCase()) {
        layer.audio.src = url;
      }
      // sync time if required (user dragged seek thumb, or wrap needed)
      const wrappedTime = (position / 1000) % (layer.audio.duration);
      if (Math.abs(layer.audio.currentTime - wrappedTime) > 200) {
        layer.audio.currentTime = wrappedTime;
      }
    } else {
      const audio = new Audio(url);
      audio.currentTime = position / 1000;
      layer = { layerId: layerId, audio: audio };
      this._audioLayers.push(layer);
    }
  }
}
